import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
	name: "notifications",
	initialState: {
		unread: [],
		read: [],
	},
	reducers: {
		populateUnread: (state, action) => ({
			...state,
			unread: [...action.payload],
		}),
		addUnread: (state, action) => {
			const prevNotificationIndex = state.unread.findIndex(
				(item) => item._id.toString() === action.payload._id
			);

			if (prevNotificationIndex < 0)
				return { ...state, unread: [action.payload, ...state.unread] };

			state.unread[prevNotificationIndex].message =
				action.payload.message;

			return state;
		},
		markAsRead: (state, action) => {
			const notification = state.unread.find(
				(item) => item._id?.toString() === action.payload
			);
			const read = [...state.read, notification];
			const unread = state.unread.filter(
				(item) => item._id?.toString() !== action.payload
			);
			return { read, unread };
		},
	},
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice.reducer;
